import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import { GreenToRedCandlesDocs } from '../../../../documentation/GreenToRedDocumentation';
import NumberInputWithUnitDropdown from '../../../../../../atomic/inputs/numberInputWithUnitDropdown/NumberInputWIthUnitDropdown';

const timeUnits = [
  {
    text: 'Min.',
    value: 'MINUTES',
  },
  {
    text: 'Day',
    value: 'DAYS',
  },
  {
    text: 'Week',
    value: 'WEEKS',
  },
  {
    text: 'Month',
    value: 'MONTHS',
  },
  {
    text: 'Quarter',
    value: 'QUARTERS',
  },
  {
    text: 'Year',
    value: 'YEARS',
  },
];

function GreenToRedCandlesModule({ state }) {
  const [
    greenToRedCandles,
    dispatchGreenToRedCandles,
    ,
    setGreenToRedCandlesEnabled,
  ] = state;

  const [inRightDirectionPctDisplay, setInRightDirectionPctDisplay] =
    useState('');
  const [retracePctDisplay, setRetracePctDisplay] = useState('');
  const [candleDurationDisplay, setCandleDurationDisplay] = useState('');
  const [minCandleHeightDisplay, setMinCandleHeightDisplay] = useState('');
  useEffect(() => {
    setGreenToRedCandlesEnabled(true);
  }, []);

  useEffect(() => {
    setInRightDirectionPctDisplay(greenToRedCandles.inRightDirectionPct * 100 ?? 0);
    setRetracePctDisplay(greenToRedCandles.retracePct * 100 ?? 0);
    setCandleDurationDisplay(greenToRedCandles.candleDuration ?? 1);
    setMinCandleHeightDisplay(greenToRedCandles.minCandleHeight ?? 0);
  }, [state]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={GreenToRedCandlesDocs} /> Green to Red Candles
      </span>

      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>Right Direction %</p>
          <NumberInputWithUnit
            direction="right"
            type="number"
            value={inRightDirectionPctDisplay}
            setValue={setInRightDirectionPctDisplay}
            onBlur={(value) =>
              dispatchGreenToRedCandles({ inRightDirectionPct: value / 100 })
            }
          >
            %
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>Retrace %</p>
          <NumberInputWithUnit
            direction="right"
            type="number"
            value={retracePctDisplay}
            setValue={setRetracePctDisplay}
            onBlur={(value) =>
              dispatchGreenToRedCandles({ retracePct: value / 100 })
            }
          >
            %
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>Candle Duration</p>
          <NumberInputWithUnitDropdown
            list={timeUnits}
            inputVal={candleDurationDisplay}
            setInputVal={setCandleDurationDisplay}
            selectVal={greenToRedCandles.timeUnit}
            onBlur={(value) =>
              dispatchGreenToRedCandles({ candleDuration: value })
            }
            setSelectVal={(value) =>
              dispatchGreenToRedCandles({ timeUnit: value })
            }
          />
          {/*   <p>Candle Duration</p>
          <NumberInputWithUnit
            direction="right"
            type="number"
            value={candleDurationDisplay}
            setValue={setCandleDurationDisplay}
            onBlur={(value) =>
              dispatchGreenToRedCandles({ candleDuration: value })
            }
          >
            min.
          </NumberInputWithUnit> */}
        </div>

        <div className={style.inputAndLabel} style={{ gridColumn: 'span 2' }}>
          <p>Min. Candle Height</p>
          <NumberInputWithUnit
            inputWidth="5em"
            direction="left"
            type="number"
            value={minCandleHeightDisplay}
            setValue={setMinCandleHeightDisplay}
            onBlur={(value) =>
              dispatchGreenToRedCandles({ minCandleHeight: value })
            }
          >
            $
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
}
GreenToRedCandlesModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default GreenToRedCandlesModule;
